import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { SLIDE_DATA } from "../../../Models/ArrowData";

const Main = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % SLIDE_DATA.length);
    }, 10000);
    return () => clearInterval(timer);
  }, [index]);

  return (
    <HomeContainer>
      {SLIDE_DATA.map((slide, i) => (
        <BgImage key={slide.id} src={slide.img} active={index === i} />
      ))}

      <InnerWrapper>
        <ContentBox key={index}>
          <Label>{SLIDE_DATA[index].label}</Label>

          {index === 0 ? (
            <DhkSpecialTitle>
              <div className="top-words">
                <div className="word word-d">
                  <span className="initial">DHK SOLUTION CORPORATION</span>
                </div>
              </div>
            </DhkSpecialTitle>
          ) : (
            <Title>{SLIDE_DATA[index].title}</Title>
          )}

          <Description>
            <div>{SLIDE_DATA[index].desc}</div>
            <div>{SLIDE_DATA[index].subDesc}</div>
          </Description>
        </ContentBox>
      </InnerWrapper>

      {/* <NavWrapper>
        <InnerWrapper style={{ height: "auto" }}>
          <Nav>
            {SLIDE_DATA.map((_, i) => (
              <NavBtn key={i} active={index === i} onClick={() => setIndex(i)}>
                <span className="num">0{i + 1}</span>
                <span className="progress-bar"></span>
              </NavBtn>
            ))}
          </Nav>
        </InnerWrapper>
      </NavWrapper> */}
    </HomeContainer>
  );
};

export default Main;

/* --- Animations --- */
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const fillProgress = keyframes`
  from { width: 0%; }
  to { width: 100%; }
`;

/* --- Styles --- */
export const HomeContainer = styled.div`
  width: 100%;
  height: 100vh; /* 명확한 높이 지정 */
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
`;

const InnerWrapper = styled.div`
  position: relative;
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  z-index: 10;
`;
export const BgImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* 기본 설정 */
  background-image: url(${(props) => "/images/Home/Background/" + props.src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover; /* 데스크탑은 꽉 채우기 */

  transition:
    opacity 1s ease,
    transform 1.5s ease;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transform: scale(${(props) => (props.active ? 1 : 1.1)});
  z-index: ${(props) => (props.active ? 1 : 0)};

  /* 모바일 최적화 */
  @media (max-width: 768px) {
    /* 1. 이미지가 절대 잘리지 않게 하려면 contain 사용 */
    /* 하지만 배경이 비어 보일 수 있으므로 꽉 채우면서 중앙을 강조하는 100% auto 추천 */
    background-size: cover;
    background-position: 65% center; /* 모바일에서 중요한 피사체가 오른쪽에 있다면 수치를 조절 */

    /* 만약 이미지 전체가 다 보이는게 중요하다면 아래 설정 사용 */
    /* background-size: contain; 
       background-color: #000; */
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* 모바일에서는 텍스트 가독성을 위해 어두운 오버레이를 더 진하게 */
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );

    @media (max-width: 768px) {
      background: rgba(0, 0, 0, 0.5);
    }
  }
`;

const ContentBox = styled.div`
  text-align: left;
  color: white;
  @media (max-width: 768px) {
    /* 모바일에서는 하단 Nav와 겹치지 않게 조금 위로 배치 */
    padding-bottom: 80px;
  }
`;

const Label = styled.h5`
  font-size: 1.2rem;
  font-weight: 600;
  color: #00d2ff;
  letter-spacing: 3px;
  margin-bottom: 20px;
  animation: ${fadeInUp} 0.8s ease-out 0.2s forwards;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 10px;
  }
`;

const DhkSpecialTitle = styled.div`
  margin-bottom: 20px;
  opacity: 1 !important;

  .top-words {
    display: flex;
    gap: 15px;
    align-items: baseline;
  }

  .word {
    display: flex;
    align-items: baseline;
    opacity: 0;

    .initial {
      font-size: 3.5rem;
      font-weight: 900;
      color: #fff;
      line-height: 1;
      text-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
    }

    .rest {
      font-size: 4.5rem;
      font-weight: 600;
      color: #fff;
      letter-spacing: 1px;
      margin-left: 15px;
    }
  }

  .word-d {
    animation: ${fadeInUp} 0.8s ease-out 0.3s forwards;
  }
  .word-h {
    animation: ${fadeInUp} 0.8s ease-out 0.5s forwards;
  }
  .word-k {
    animation: ${fadeInUp} 0.8s ease-out 0.7s forwards;
  }

  @media (max-width: 1024px) {
    .word {
      font-size: 6rem;
    }

    .word .rest {
      font-size: 3.5rem;
    }
  }

  @media (max-width: 768px) {
    .top-words {
      gap: 10px;
    }
    .word {
      .rest {
        font-size: 8vw;
        margin-left: 8px;
      }
      .initial {
        font-size: 3rem;
      }
    }
  }
  @media (max-width: 400px) {
    .word {
      .initial {
        font-size: 2.5rem;
      }
    }
  }
`;

const Title = styled.h1`
  font-size: 4.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
  text-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
  word-break: keep-all;
  animation: ${fadeInUp} 1s ease-out 0.4s forwards;

  @media (max-width: 1024px) {
    font-size: 3rem;
  }
  @media (max-width: 768px) {
    font-size: 5.5vw;
  }
`;

const Description = styled.p`
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 40px;
  font-weight: 300;
  line-height: 1.6;
  max-width: 700px;
  word-break: keep-all;
  animation: ${fadeInUp} 1s ease-out 1.1s forwards;
  div {
    color: rgba(255, 255, 255, 0.5);
  }
  @media (max-width: 768px) {
    font-size: 3vw;
    line-height: 1.5;
    max-width: 100%;
  }
`;

const NavWrapper = styled.div`
  position: absolute;
  bottom: 8%;
  left: 0;
  width: 100%;
  z-index: 20;

  @media (max-width: 768px) {
    bottom: 5%;
  }
`;

const Nav = styled.div`
  display: flex;
  gap: 30px;
  @media (max-width: 768px) {
    gap: 15px;
  }
`;

const NavBtn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 80px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 60px; /* 모바일에서 버튼 너비 축소 */
    gap: 5px;
  }

  .num {
    font-size: 1rem;
    font-weight: 700;
    color: ${(props) => (props.active ? "#fff" : "rgba(255, 255, 255, 0.4)")};
    transition: color 0.3s;
    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
  }

  .progress-bar {
    position: relative;
    width: 100%;
    height: 2px;
    background: rgba(255, 255, 255, 0.2);

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: #00d2ff;
      ${(props) =>
        props.active &&
        css`
          animation: ${fillProgress} 10s linear forwards;
        `}
    }
  }
`;
